import { TemplateModel } from '@picsart/growth-rc/Template';

const pairItems = (templates: TemplateModel[]) =>
  templates.reduce((result, _, index) => {
    if (index % 2 === 0) {
      result.push(templates.slice(index, index + 2));
    }
    return result;
  }, []);

export default pairItems;
